import { moduleFactory } from "@/factories/module";
import { _controlFlowLogicNotImplementedError } from "@/modules/control-flow/notImplemented";
import { _assertUnreachableCase } from "@/modules/control-flow/unreachable";

export const controlFlowModule = moduleFactory.create({
  notImplementedError: _controlFlowLogicNotImplementedError,
  assertUnreachableCase: _assertUnreachableCase,
});
